import { render, staticRenderFns } from "./form-info.vue?vue&type=template&id=4deaf2f2&scoped=true&"
import script from "./form-info.vue?vue&type=script&lang=js&"
export * from "./form-info.vue?vue&type=script&lang=js&"
import style0 from "./form-info.vue?vue&type=style&index=0&id=4deaf2f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4deaf2f2",
  null
  
)

export default component.exports